import React from 'react';

const HoldingHandsShield: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="6"
      d="M63.755 84.303c-3.085-.907-15.132-5.37-15.132-19.159V54.37c3.26-1.22 7.688-2.3 14.801-2.3 5.736 0 10.914.784 15.43 2.335v10.74c0 13.527-12.1 17.903-15.099 19.14v.018zm-31.607-33.35c8.02 0 14.522-6.502 14.522-14.521 0-8.02-6.503-14.522-14.522-14.522-8.02 0-14.523 6.503-14.523 14.522s6.503 14.521 14.523 14.521zM5.386 107L8.7 70.704c1.22-9.919 9.31-14.974 17.19-14.277 8.142.715 13.494 7.53 14.47 15.463 1.57 12.5 10.39 19.856 21.758 20.85 3.557.314 6.154 3.434 5.875 7.008-.314 4.009-3.678 5.875-6.572 5.875-15.639-1.116-27.198-10.355-31.783-21.722m8.786 12.307l-.906 10.791"
    ></path>
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="6"
      d="M122.613 106.982l-3.243-35.65c-1.185-9.38-8.978-14.766-16.858-13.999-7.985.785-13.233 7.374-14.192 15.167-1.534 12.238-11.297 20.117-24.198 20.745"
    ></path>
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="6"
      d="M63.738 105.205c9.973.505 20.503-3.696 26.169-8.612l1.22 10.372m19.492-69.331c0-7.862-6.364-14.242-14.227-14.242-7.862 0-14.226 6.38-14.226 14.242 0 7.863 6.381 14.226 14.227 14.226 7.845 0 14.226-6.363 14.226-14.226z"
    ></path>
  </svg>
);

export default HoldingHandsShield;
